module.exports = __webpack_public_path__ + "238a55b58e417caf30659e8167302f4c.svg";